var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompanystack = function SvgCompanystack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#6BE",
    fillRule: "evenodd",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 2,
    y: 2,
    fill: "#c1c1c1",
    fillRule: "evenodd",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 4,
    y: 4,
    fill: "#6BE",
    fillRule: "evenodd",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 0.5,
    d: "M13.021 11.663c-.894 0-1.57-.702-1.57-1.634 0-.937.676-1.64 1.57-1.64.892 0 1.568.703 1.568 1.64 0 .932-.676 1.634-1.568 1.634m0-4.117c-.763 0-1.464.337-1.932.92a2.5 2.5 0 0 0-.54-.637q-.018-.02-.053-.013a.06.06 0 0 0-.037.037l-.284.78c-.007.02 0 .041.01.06.23.296.359.656.359 1.043v4.523c0 .032.022.08.055.08h.728c.03 0 .05-.048.05-.08v-2.36l.036.03a2.5 2.5 0 0 0 1.605.577 2.445 2.445 0 0 0 2.473-2.471c0-1.395-1.083-2.489-2.47-2.489m-3.202.26h-.891c-.022 0-.043-.007-.05.013L7.04 11.386 5.2 7.822c-.014-.019-.033-.016-.057-.016h-.897c-.024 0-.043-.01-.055.008s-.012.03 0 .047l2.33 4.332c.019.036.156.313.518.313.361 0 .492-.271.516-.316L9.87 7.852c.01-.017.01-.018 0-.038-.013-.018-.03-.008-.051-.008"
  })));
};
export default SvgCompanystack;